import { InductionFrame, inductionStepIds } from '@features/it-induction/components/InductionFrame'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

const inductionSearchSchema = z.object({
    step: z.enum(inductionStepIds).optional(),
})

export const Route = createFileRoute('/_nolayout/induction/')({
  component: RouteComponent,
  staticData: {
    title: 'IT Induction',
  },
  validateSearch: zodValidator(inductionSearchSchema),
})

function RouteComponent() {
  const { step } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <InductionFrame
      step={step}
      showLanding={!step}
      onStepChange={(nextStep) => {
        void navigate({
          search: { step: nextStep },
        })
      }}
    />
  )
}
